import React from "react";

const PanelistCard = ({
  panelist,
  roleType,
  onRemove,
  loading,
  canRemove = true,
  addedByRole,
  canEdit = true,
}) => {
  const getRoleLabel = () => {
    if (addedByRole === "CLIENT_MEMBER") {
      return "CLIENT (FEMA)";
    } else if (
      addedByRole === "COMMUNITY_MEMBER" ||
      addedByRole === "CADRE_MEMBER"
    ) {
      return "COMMUNITY";
    }
    return roleType;
  };

  const getRoleBadgeColor = () => {
    if (addedByRole === "CLIENT_MEMBER") {
      return "bg-purple-100 text-purple-800";
    } else if (
      addedByRole === "COMMUNITY_MEMBER" ||
      addedByRole === "CADRE_MEMBER"
    ) {
      return "bg-green-100 text-green-800";
    }
    return "bg-gray-100 text-gray-800";
  };

  return (
    <div className="p-3 bg-gray-50 rounded-lg border border-gray-200">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="flex items-center space-x-2 mb-1">
            <h4 className="font-medium text-gray-900">
              {panelist.user?.name || panelist.name || "Unknown Member"}
            </h4>
            <span
              className={`px-2 py-0.5 text-xs font-medium rounded-full ${getRoleBadgeColor()}`}
            >
              {getRoleLabel()}
            </span>
          </div>
          <p className="text-sm text-gray-600">
            {panelist.user?.email || panelist.email || "No email"}
          </p>
          <p className="text-xs text-gray-500 mt-1">
            Added: {new Date(panelist.joinedDate).toLocaleDateString()}
          </p>
        </div>
        {canEdit && (
          <button
            onClick={() => onRemove(panelist.id)}
            disabled={loading || !canRemove}
            className="px-3 py-1 bg-red-500 text-white text-sm rounded hover:bg-red-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            title={
              !canRemove
                ? "You can only remove panelists you added"
                : "Remove panelist"
            }
          >
            Remove
          </button>
        )}
      </div>
    </div>
  );
};

export default PanelistCard;
